export default __webpack_public_path__ + "static/1346-7e7ddd4f3b79b9525e5ee9f07e802cb6.gif";